<template>
  <div class="px-5">
    <div class="lg:w-1/3 bg-gray-800 p-2 ml-auto text-right text-gray-300 rounded-lg">
      <h3>Hi there {{ user.displayName }}</h3>
      <h3>Your Email : {{ user.email }}</h3>
    </div>
    <div class="lg:w-1/3 mt-3 bg-cyan-900 p-2 ml-auto text-right text-gray-300 rounded-lg">
      <h3>Note</h3>
      <p class="text-sm">isi kolom tags sesuai topik dan tekan enter pada keyboard sampai muncul kata yang dimaksud dibawah kolom, baru klik tombol Create</p>
    </div>
    <div class="container mt-6">
      <div class="flex flex-wrap grid lg:grid-cols-3  ">
        <div class="p-4">
          <router-link :to="{ name: 'CreateTodolists' }">
            <figure class="md:flex rounded-lg bg-white dark:bg-gray-800 md:p-0">
              <div class="p-3">
                <h3 class="text-cyan-600 text-lg text-center mb-5">Create ToDoList</h3>
                <p class="text-gray-500 text-sm italic text-center">Buat tugas atau pengumuman</p>
              </div>
            </figure>
          </router-link>
        </div>

        <div class="p-4">
          <router-link :to="{ name: 'CreatePosts' }">
            <figure class="md:flex rounded-lg bg-white dark:bg-gray-800 md:p-0">
              <div class="p-3">
                <h3 class="text-cyan-600 text-lg text-center mb-5">Create Post</h3>
                <p class="text-gray-500 text-sm italic text-center">Buat artikel atau materi pelajaran</p>
              </div>
            </figure>
          </router-link>
        </div>

        <div class="p-4">
          <router-link :to="{ name: 'UserTodolists' }">
            <figure class="md:flex rounded-lg bg-white dark:bg-gray-800 md:p-0">
              <div class="p-3">
                <h3 class="text-cyan-600 text-lg text-center mb-5">My-ToDoList</h3>
                <p class="text-gray-500 text-sm italic text-center">Lihat semua pengumuman yang sudah dibuat</p>
              </div>
            </figure>
          </router-link>
        </div>

        <div class="p-4">
          <router-link :to="{ name: 'UserPosts' }">
            <figure class="md:flex rounded-lg bg-white dark:bg-gray-800 md:p-0">
              <div class="p-3">
                <h3 class="text-cyan-600 text-lg text-center mb-5">My-PostList</h3>
                <p class="text-gray-500 text-sm italic text-center">Lihat semua tulisan yang sudah dibuat</p>
              </div>
            </figure>
          </router-link>
        </div>
        <div class="p-4">
          <router-link :to="{ name: 'Hangman' }">
            <figure class="md:flex rounded-lg bg-white dark:bg-gray-800 md:p-0">
              <div class="p-3">
                <h3 class="text-cyan-600 text-lg text-center mb-5">Hangman</h3>
              </div>
            </figure>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "../components/SideBar.vue"
import getUser from "@/composables/getUser"
import { useRouter } from "vue-router"
// import getCollection from "@/composables/getCollection"
// import NoteView from "@/components/note/NoteView.vue"
// import TagNote from "@/components/note/TagNote.vue"
export default {
  components: { SideBar },
  setup() {
    const { user } = getUser()
    const router = useRouter()
    // const { documents: notes } = getCollection("notes", ["userId", "==", user.value.uid])
    // const { documents: posts } = getCollection("posts", ["userId", "==", user.value.uid])
    return { user }
  },
}
</script>

<style scoped></style>
